// Module
var code = "<div ng-controller=\"wizard\"  class=\"page-content\">\n\n    <vx-wizard steps=\"steps\" hash=\"item.hash\" finish=\"finish\"></vx-wizard>\n\n</div>\n";
// Exports
module.exports = code;